import { IDataProspecto } from '../../prospecto';


export interface ICodigoOtp {
  last_id: number;
  count: number;
  next: string;
  previous: string;
  numero_paginas: number;
  data: IDataCodigoOtp[];

  //aux
}

export interface IDataCodigoOtp {
  id_codigo_otp: string;
  codigo: string;
  numero_referencia: string;
  otp: string;
  celular: string;
  email: string | null;
  validado: boolean;
  estado_solicitud: string | null;
  estado: boolean;
  fecha_creacion: string;
  fecha_modificacion: string;
  fecha_hora_expiracion: string;
  prospecto_data: IDataProspecto[];
  estado_otp: string;
}

export interface IDataCodigoOtpParams extends Partial<IDataCodigoOtp> {
  page?: number;
  page_size?: number;
}

export interface ValidarCodigoOtp {
  codigo: string;
  identificacion?: string;
}

export interface GenerarCodigoOtp {
  celular: string;
  identificacion: string;
  //prospecto_id: number;
}

export enum CodigoOTPEstadoEnum {
  PENDIENTE = '1',
  CADUCADO = '2',
  VERIFICADO = '3',
}
